import { render, staticRenderFns } from "./_add_items_checklist.vue?vue&type=template&id=2987f1f6&scoped=true&"
import script from "./_add_items_checklist.vue?vue&type=script&lang=js&"
export * from "./_add_items_checklist.vue?vue&type=script&lang=js&"
import style0 from "./_add_items_checklist.vue?vue&type=style&index=0&id=2987f1f6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987f1f6",
  null
  
)

export default component.exports